var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../../../../api/axios";
import { PaymentProcessor, } from "../../types/PaymentProcessorTypes";
import { LogLevel, } from "../../../../../Shared/hooks/useLogging/Logging-types";
import { withoutEmptyValues } from "../../../../../Shared/analytics/ecommerce";
export const initPaymentMethodCreation = (setLoading, setError, setToken, setPublicKey, setClientSecret, setPaymentProcessor, datadogLog) => () => __awaiter(void 0, void 0, void 0, function* () {
    setLoading(true);
    yield axiosPrivate
        .post(`/InitPaymentMethodCreation`)
        .then(({ data }) => {
        var _a;
        if (!data.success) {
            const errorMessage = (_a = data.message) !== null && _a !== void 0 ? _a : "Failed to initialize payment method creation.";
            datadogLog(errorMessage, LogLevel.ERROR);
            setError("Failed to initialize payment method creation.");
        }
        if (data.clientSecret) {
            setClientSecret(data.clientSecret);
            setPaymentProcessor(PaymentProcessor.STRIPE);
        }
        if (data.hostedFormToken) {
            setToken(data.hostedFormToken);
            setPaymentProcessor(PaymentProcessor.AUTHORIZE);
        }
        if (data.publicKey) {
            setPublicKey(data.publicKey);
            setPaymentProcessor(PaymentProcessor.TAP);
        }
    })
        .catch((err) => {
        var _a;
        console.error(err);
        const errorMessage = (_a = err.message) !== null && _a !== void 0 ? _a : "Failed to initialize payment method creation.";
        datadogLog(errorMessage, LogLevel.ERROR, {}, err);
        setError("Failed to create setup intent.");
        return {
            success: false,
            message: "Failed to initialize payment method creation.",
        };
    })
        .finally(() => {
        setLoading(false);
    });
});
export const createPaymentMethod = (setError, setLoading, setCustomerCreditCards, logCreatePaymentMethodEvent, datadogLog, customerCreditCards) => (body) => __awaiter(void 0, void 0, void 0, function* () {
    setLoading(true);
    const res = yield axiosPrivate
        .post("/CreatePaymentMethod", body)
        .then(({ data }) => {
        var _a;
        if (data.success) {
            logCreatePaymentMethodEvent();
            if (customerCreditCards === null || customerCreditCards === void 0 ? void 0 : customerCreditCards.length) {
                const otherCards = customerCreditCards
                    .filter((card) => card.id !== data.card.id)
                    .map((card) => {
                    return Object.assign(Object.assign({}, card), { isPrimary: body.isPrimary ? false : card.isPrimary });
                });
                setCustomerCreditCards(body.isPrimary ? [data.card, ...otherCards] : [...otherCards, data.card]);
            }
            else {
                setCustomerCreditCards([data.card]);
            }
        }
        else {
            const errorMessage = (_a = data === null || data === void 0 ? void 0 : data.message) !== null && _a !== void 0 ? _a : "Failed to add payment profile.";
            datadogLog(errorMessage, LogLevel.ERROR);
        }
        return data;
    })
        .catch((err) => {
        var _a;
        console.error(err);
        const errorMessage = (_a = err.message) !== null && _a !== void 0 ? _a : "Failed to add payment profile.";
        datadogLog(errorMessage, LogLevel.ERROR, {}, err);
        setError("Failed to add payment profile.");
        return { success: false, message: "Failed to add payment profile." };
    });
    setLoading(false);
    return res;
});
export const logCreatePaymentMethodEvent = (logReactPixel, createKlaviyoEvent, track, currency, order) => () => {
    logReactPixel("AddPaymentInfo");
    createKlaviyoEvent("AddPaymentInfo");
    // value and items only exist when an order is being paid for; saving a card
    // from account settings prices nothing, so those keys are omitted there.
    track("add_payment_info", withoutEmptyValues({ currency, value: order === null || order === void 0 ? void 0 : order.value, items: order === null || order === void 0 ? void 0 : order.items }));
};
